export default "__VITE_ASSET__BXTEIEII__"